export const TEAM_NAME = 'growth-artemis';
export const PACKAGE_NAME = 'jiraTrialAssistant';
export const ANALYTICS_SOURCE_NAME = 'jiraTrialAssistant';
export type TrialAssistantSource = 'jira-trial-welcome-modal' | 'jira-trial-reminder-spotlight';
